import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SundaySurplusPage = lazy(() => import('../pages/sunday-surplus/page'));
const TheSystemPage = lazy(() => import('../pages/the-system/page'));
const BookPage = lazy(() => import('../pages/book/page'));
const BookThankYouPage = lazy(() => import('../pages/book/thank-you/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const UnsubscribePage = lazy(() => import('../pages/unsubscribe/page'));
const SendSundaySurplusPage = lazy(() => import('../pages/send-sunday-surplus/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sunday-surplus',
    element: <SundaySurplusPage />,
  },
  {
    path: '/builders',
    element: <Navigate to="/sunday-surplus" replace />,
  },
  {
    path: '/the-system',
    element: <TheSystemPage />,
  },
  {
    path: '/the-system/thank-you',
    element: <Navigate to="/the-system" replace />,
  },
  {
    path: '/book',
    element: <BookPage />,
  },
  {
    path: '/book/thank-you',
    element: <BookThankYouPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/unsubscribe',
    element: <UnsubscribePage />,
  },
  {
    path: '/send-sunday-surplus',
    element: <SendSundaySurplusPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;